import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import "tom-select/dist/css/tom-select.bootstrap4.css"

// Connects to data-controller="tom-select"
// <select multiple>を検索可能なタグ選択UIに置き換える。
// ネイティブのctrl/cmd+クリック多重選択は分かりにくいため、こちらに統一する。
// exclusiveValueを指定すると、その選択肢(「なし」等)は他の選択肢と同時に選べない。
export default class extends Controller {
  static values = {
    placeholder: { type: String, default: "選択してください" },
    exclusive: String
  }

  connect() {
    this.tomSelect = new TomSelect(this.element, {
      plugins: ["remove_button"],
      placeholder: this.placeholderValue
    })

    if (this.hasExclusiveValue) {
      this.tomSelect.on("item_add", (value) => this.applyExclusive(value))
    }
  }

  disconnect() {
    this.tomSelect?.destroy()
    this.tomSelect = null
  }

  // 排他選択肢を選んだら他を全て外し、それ以外を選んだら排他選択肢を外す
  applyExclusive(addedValue) {
    const removeTargets = addedValue === this.exclusiveValue
      ? this.tomSelect.items.filter((value) => value !== this.exclusiveValue)
      : this.tomSelect.items.filter((value) => value === this.exclusiveValue)

    // silentでもremoveItemは元の<select>の選択状態を更新する(イベント発火のみ抑止)
    removeTargets.forEach((value) => this.tomSelect.removeItem(value, true))
  }
}
